import { ROLES } from '@/shared/constants/roles';
import { AI_PACKAGE_FEATURE_KEYS, AI_PACKAGE_FLAGS } from '@/shared/constants/packageFeatures';

export const podcastRoutes = [
  {
    path: 'podcast',
    name: 'podcast',
    component: () => import('./views/PodcastView.vue'),
    meta: {
      requiredRole: ROLES.INSTRUCTOR,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.CONTENT_TOOLS,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.podcastGeneration,
    },
  },
  {
    path: 'podcasts',
    name: 'podcasts',
    component: () => import('./views/PodcastView.vue'),
    meta: {
      requiredRole: ROLES.INSTRUCTOR,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.CONTENT_TOOLS,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.podcastGeneration,
    },
  },
];
